import React, { Component } from 'react'
import style from './style.module.less'
import { inject, observer } from 'mobx-react'
import { hashHistory } from 'react-router'
import { Flex } from 'hljd'
import { getMoreTextColor } from '@components/LocalMerchant/Decoration/util'
import Arrow from '../Arrow'

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const {
      decorationStore: { newThemeConfig, theme },
      text,
      link
    } = this.props

    const color = getMoreTextColor(theme)

    return (
      <Flex
        vc
        hc
        className={style.more}
        onClick={() => {
          link && hashHistory.push(link)
        }}
        style={{
          borderTop: `1px solid ${newThemeConfig['splitLine']}`,
          color
        }}
      >
        <Flex vc>
          <span className={style.text}>{text}</span>
          <Arrow style={{ color, marginTop: 2 }} />
        </Flex>
      </Flex>
    )
  }
}
